import { useCallback } from 'react';
import { useCampaignEditorContext } from '../hooks/useCampaignEditorContext';
import { TargetAudienceType } from '../CampaignEditorState';

export const useSetSubjectLine = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (audience: TargetAudienceType, subjectLine: { id: string; label: string }) => {
      dispatch({ type: 'SET_SUBJECT_LINE', payload: { [audience]: subjectLine } });
    },
    [dispatch],
  );
};
